import { useState } from 'react';

import PropTypes from 'prop-types';

import ConfirmModal from '#globalComponents/Overlay/ConfirmModal';
import BulkActionsBar from '#globalComponents/Table/actions/BulkActionsBar';

import { useBulkDeleteDeals } from '../../../models/deals/mutations';

import { withPipelineScope } from './withPipelineScope';

const dealsLabel = (count) => `${count.toLocaleString('de-DE')} ${count === 1 ? 'Deal' : 'Deals'}`;

/**
 * Selection bar of the deal list: count, clear and delete. Non-destructive actions live in
 * DealScopeActions in the table's actions slot.
 */
const DealBulkActions = ({ pipelineId, selection }) => {
	const [isDeleteOpen, setIsDeleteOpen] = useState(false);
	const bulkDeleteDeals = useBulkDeleteDeals();
	const { selectAllInFilter, count, clear, toScope, entityLabel } = selection;

	const handleDelete = () =>
		bulkDeleteDeals.mutate(withPipelineScope(toScope(), pipelineId), {
			onSuccess: () => {
				clear();
				setIsDeleteOpen(false);
			},
		});

	return (
		<>
			<BulkActionsBar
				selectedCount={count}
				entityLabel={entityLabel}
				onClear={clear}
				onDelete={() => setIsDeleteOpen(true)}
			/>

			<ConfirmModal
				isOpen={isDeleteOpen}
				onClose={() => setIsDeleteOpen(false)}
				onConfirm={handleDelete}
				title={`${dealsLabel(count)} löschen`}
				message={
					selectAllInFilter
						? `Alle ${dealsLabel(count)} dieser Pipeline, die den aktuellen Filtern entsprechen, werden in den Papierkorb verschoben – auch die auf anderen Seiten. Fortfahren?`
						: `Möchten Sie ${dealsLabel(count)} wirklich löschen? Die Deals werden in den Papierkorb verschoben.`
				}
				confirmText="Löschen"
				isLoading={bulkDeleteDeals.isPending}
			/>
		</>
	);
};

DealBulkActions.propTypes = {
	pipelineId: PropTypes.string.isRequired,
	/** From useScopedSelection. */
	selection: PropTypes.shape({
		selectAllInFilter: PropTypes.bool.isRequired,
		count: PropTypes.number.isRequired,
		clear: PropTypes.func.isRequired,
		entityLabel: PropTypes.object.isRequired,
		toScope: PropTypes.func.isRequired,
	}).isRequired,
};

export default DealBulkActions;
